// Central registry of data-testid values used by automated E2E tests.

export const ADMIN = {
  loginEmailInput: 'admin-login-email-input',
  loginPasswordInput: 'admin-login-password-input',
  loginSubmitButton: 'admin-login-submit-button',
  sidebarDashboard: 'admin-sidebar-dashboard',
  sidebarLogout: 'admin-sidebar-logout',
  sidebarSection: 'admin-sidebar-section',
  dashboardStats: 'admin-dashboard-stats',
  sectionTile: 'admin-section-tile',
  quickPublishButton: 'admin-quick-publish-button',
  newReportButton: 'admin-new-report-button',
  reportSearchInput: 'admin-report-search-input',
  reportRow: 'admin-report-row',
  editButton: 'admin-edit-report',
  deleteButton: 'admin-delete-report',
  toggleStatusButton: 'admin-toggle-status',
  formCompanyName: 'report-company-name-input',
  formSymbol: 'report-symbol-input',
  formSector: 'report-sector-input',
  formIndustry: 'report-industry-input',
  formScore: 'report-score-input',
  formRecommendation: 'report-recommendation-select',
  formDate: 'report-date-input',
  formCurrentPrice: 'report-current-price-input',
  formMarketCap: 'report-market-cap-input',
  formSummary: 'report-summary-input',
  formHighlights: 'report-highlights-input',
  formStrengths: 'report-strengths-input',
  formRisks: 'report-risks-input',
  formMetrics: 'report-metrics-input',
  formPdfUpload: 'report-pdf-upload',
  formLogoUpload: 'report-logo-upload',
  formCoverUpload: 'report-cover-upload',
  formPublishButton: 'report-publish-button',
  formDraftButton: 'report-draft-button',
};

export const SITE = {
  nav: 'site-nav',
  navLogo: 'site-nav-logo',
  navSectionLink: 'nav-section-link',
  navSearchInput: 'nav-search-input',
  heroSearchInput: 'hero-search-input',
  heroSearchResults: 'hero-search-results',
  trendingSection: 'trending-section',
  latestResearch: 'latest-research-section',
  sectionBlock: 'home-section-block',
  sectionHomeStrip: 'home-section-strip',
  reportCard: 'report-card',
  sectionPage: 'section-page',
  sectionSearchInput: 'section-search-input',
  reportPage: 'report-page',
  reportScore: 'report-kira-score',
  reportRecommendation: 'report-recommendation-badge',
  reportHighlights: 'report-key-highlights',
  reportStrengths: 'report-strengths',
  reportRisks: 'report-risks',
  reportMetrics: 'report-metrics',
  reportPdfFrame: 'report-pdf-frame',
  reportDownloadBtn: 'report-download-button',
  relatedReports: 'related-reports',
  aboutSection: 'about-section',
  footer: 'site-footer',
};
